/* global Swiper */
Wee.fn.make('testimonialSwiper', {
	init: function() {
		this.testimonialSwiper = $('ref:testimonialSwiper');

		if (this.testimonialSwiper.length) {
			this.$private.initTestimonalSwiper();
		}
	},
	unload: function() {
		if (this.testimonialSwiper.length) {
			this.testimonialSwiper[0].swiper.destroy();
		}
	}
}, {
	initTestimonalSwiper: function() {
		var testimonials = new Swiper(this.$public.testimonialSwiper, {
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			slidesPerView: 'auto',
			pagination: '.js-swiper-pagination',
			paginationClickable: true
		});
	}
});